export default "__VITE_ASSET__786d03ec__"